<template>
  <v-row class="text-center">
    <v-col :cols="12" v-if="$vuetify.breakpoint.xsOnly" :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'">
      <h1 class="headline font-weight-black">
        <span class="subtitle-1 font-weight-regular" @click="openMusitelligence" style="cursor: pointer">
          Musitelligence
        </span>
      </h1>
    </v-col>
    <v-col :cols="12" v-else :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'">
      <h1 class="display-1 font-weight-black">
        <span class="title font-weight-medium" @click="openMusitelligence" style="cursor: pointer">
          Musitelligence
        </span>
      </h1>
    </v-col>
    <v-col cols="12" class="font-weight-bold title warning">
      ATTENTION: Scale Heaven was renamed to Music Guru and moved to a new address.<br>
      This address will soon be hosting a different app so make sure to Move to our new address
      <a href="https://music-guru.musitelligence.com/" target="_blank" rel="noreferrer noopener">HERE</a>
      if you are on the web or update the app if on android.
    </v-col>
    <v-col :cols="12"
           v-if="!isStandAlone && !isTWA"
           @click="viewInstallInstructions"
           :class="`font-weight-regular ${$vuetify.breakpoint.mdAndUp ? 'body-1' :'body-2'}`"
           style="cursor: pointer;">
      <span style="border-bottom: solid 1px">
        Install everywhere
        <app-icon icon="info" :size="18"/>
      </span>
    </v-col>
    <v-col :cols="12"
           v-for="section in sections"
           :key="section.name">
      <router-link :to="section.route">
        <v-btn outlined
               :block="$vuetify.breakpoint.xsOnly"
               :small="$vuetify.breakpoint.xsOnly"
               :large="$vuetify.breakpoint.smAndUp"
               :style="{width: $vuetify.breakpoint.smAndUp ? '30vw' : '90vw'}"
               :class="`elevation-2 ${$vuetify.breakpoint.mdAndUp ? 'body-1' : 'body-2'}`">
          {{ section.name }}<br>
        </v-btn>
      </router-link>
    </v-col>
    <v-col :cols="12" v-if="isIOS" class="caption warning">
      ATTENTION: Make sure the mute switch is off or you wont hear anything.
    </v-col>
    <v-col :cols="12" class="font-weight-medium">
      <a :href="sm.link" target="_blank" rel="noreferrer noopener" v-for="sm in socialMedia"
         :key="sm.name">
        <v-avatar size="32px" @click="socialMediaClicked(sm)">
          <img :src="require(`assets/img/social-media/${sm.name}.png`)">
        </v-avatar>
      </a>
      <br>
      <v-btn text color="accent" small>
        <a href="https://www.patreon.com/Seanitzel" target="_blank" rel="noreferrer noopener"
           class="text--primary text-none" style="border-bottom: solid 1px">
          Please support us for more
        </a>
      </v-btn>
    </v-col>
    <v-col :cols="12" class="py-3">
      <v-btn :small="$vuetify.breakpoint.smAndDown" outlined class="elevation-1" @click="newsClicked">
        What's new?
      </v-btn>
    </v-col>
    <v-dialog v-model="installInstructionsDialog" max-width="350">
      <app-dialog @close="installInstructionsDialog = false">
        <template #title>Installation instructions</template>
        <install-instructions/>
      </app-dialog>
    </v-dialog>
    <v-dialog v-model="news" max-width="500">
      <the-news-dialog v-if="news" @close="news=false"/>
    </v-dialog>
  </v-row>
</template>

<script>
  import { isIOS, isStandAlone, isTWA } from 'misc/DeviceInfo'
  import SegmentIO                      from 'reporting/SegmentIO'
  import homeRoutes                     from 'assets/app-data/home-routes'
  import appConfig                      from 'assets/app-data/app-config'

  export default {
    name: 'Home',

    head: {
      title: function() {
        return {
          inner: 'Home',
        }
      },
      meta:  appConfig.meta,
    },

    components: {
      TheNewsDialog:       () => import(/* webpackChunkName: "home" */ 'sections/framework/TheNewsDialog'),
      InstallInstructions: () => import(/* webpackChunkName: "home" */ 'sections/framework/InstallInstructions'),
      AppDialog:           () => import(/* webpackChunkName: "app-main" */ 'components/AppDialog'),
    },

    data() {
      return {
        appName:                   appConfig.name,
        isTWA:                     isTWA(),
        isIOS:                     isIOS(),
        isStandAlone:              isStandAlone(),
        installInstructionsDialog: false,
        sections:                  homeRoutes,
        socialMedia:               [
          {
            name: 'twitter',
            link: 'https://twitter.com/musitelligence',
          },
          {
            name: 'facebook',
            link: 'https://www.facebook.com/musitelligence',
          },
        ],
        news:                      false,
      }
    },

    methods: {
      viewInstallInstructions() {
        SegmentIO.viewInstallInstructions()
        this.installInstructionsDialog = true
      },

      socialMediaClicked({ name }) {
        SegmentIO.socialMediaClicked(name)
      },

      newsClicked() {
        SegmentIO.viewNewsClicked()
        this.news = true
      },

      openMusitelligence() {
        window.open('https://musitelligence.com/', '_blank')
      },
    },
  }
</script>
